import { atom } from 'recoil';
import { BasketSummary } from '../interfaces/Basket/BasketSummary';

export const basketAtom = atom<BasketSummary | undefined>({
  key: 'basketState',
  default: undefined,
});
